import { render, staticRenderFns } from "./two-column-layout.vue?vue&type=template&id=a30bf92a&scoped=true"
import script from "./two-column-layout.vue?vue&type=script&lang=js"
export * from "./two-column-layout.vue?vue&type=script&lang=js"
import style0 from "./two-column-layout.vue?vue&type=style&index=0&id=a30bf92a&prod&scoped=true&lang=css"
import style1 from "./two-column-layout.vue?vue&type=style&index=1&id=a30bf92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30bf92a",
  null
  
)

export default component.exports